"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpIssueRendererFactory = void 0;
const lib_pages_1 = __importDefault(require("@opsbase/lib-pages"));
const IssueStatusCountChips_1 = __importDefault(require("@opsbase/web-chips/IssueStatusCountChips"));
const useNav_1 = __importDefault(require("@opsbase/web-nav/useNav"));
const react_1 = __importStar(require("react"));
const OpIssueRendererFactory = () => (op) => {
    var _a;
    const { goTo } = (0, useNav_1.default)();
    const handleClick = (0, react_1.useCallback)(() => {
        goTo(lib_pages_1.default.OP_VIEW_ISSUES, { id: op.id });
    }, [goTo, op.id]);
    if (!((_a = op === null || op === void 0 ? void 0 : op.issues) === null || _a === void 0 ? void 0 : _a.length))
        return null;
    return react_1.default.createElement(IssueStatusCountChips_1.default, { issues: op.issues, onClick: handleClick });
};
exports.OpIssueRendererFactory = OpIssueRendererFactory;
exports.default = exports.OpIssueRendererFactory;
